import { action } from 'satcheljs';

export default action(
    'removeItemWithIdFromStore',
    function removeItemWithIdFromStore(itemId: string) {
        return { itemId };
    }
);
